import React, { useEffect, useRef, useContext, useState } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { FontSizeContext } from "../../context/fontSizeContext";

const FinancialResultsContainer = ({ contRef }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const [modalItem, setModalItem] = useState(null);
    const handleModalOpen = (item) => {
        setModalItem(item);
    };

    const handleModalClose = () => {
        setModalItem(null);
    };

    const { fontSize } = useContext(FontSizeContext);
    const textRefs = useRef([]);
    const [defaultSizes, setDefaultSizes] = useState([]);

    const adjustFontSize = (change) => {
        textRefs.current.forEach((element, index) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                const currentSize = parseFloat(computedStyle.fontSize);
                const newSize = currentSize + change;
                element.style.fontSize = `${newSize}px`;
            }
        });
    };

    const resetFontSize = () => {
        textRefs.current.forEach((element, index) => {
            if (element && defaultSizes[index] !== null) {
                element.style.fontSize = `${defaultSizes[index]}px`;
            }
        });
    };

    // Files in the public folder are served from the root URL "/"
    useEffect(() => {
        fetch("../../data/investor-grievances.json")
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch JSON");
                }
                return response.json();
            })
            .then((jsonData) => {
                setData(jsonData);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error loading JSON:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        if (fontSize == 0) {
            resetFontSize();
        } else {
            adjustFontSize(fontSize);
        }
    }, [fontSize]);

    useEffect(() => {
        const sizes = textRefs.current.map((element) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                return parseFloat(computedStyle.fontSize);
            }
            return null;
        });
        setDefaultSizes(sizes);
    }, []);
    return (
        <>
            <style>
                {`
                .card-title {
                    color: #008080;
                    font-size: 1.1rem;
                    font-weight: 600;
                }

                .btn-success {
                    background-color: #4CAF50;
                    border: none;
                    box-shadow: 0 4px #2e7d32;
                    font-weight: 500;
                    padding: 10px 20px;
                    border-radius: 20px;
                    color: white;
                    text-decoration: none;
                    display: inline-block;
                }

                .btn-success:hover {
                    background-color: #45a049;
                }

                .modal-backdrop {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: rgba(0, 0, 0, 0.6);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 999;
                    cursor: pointer;
                }

                .modal-content {
                    background: white;
                    padding: 30px;
                    border-radius: 10px;
                    max-width: 500px;
                    width: 90%;
                    position: relative;
                }

                .modal-close {
                    position: absolute;
                    top: 10px;
                    right: 15px;
                    font-size: 24px;
                    font-weight: bold;
                    cursor: pointer;
                    color: green;
                }
                `}
            </style>
            <div className="single-service  pb-0 pt-10" ref={contRef}>
                <div className="container">
                    <div className="row justify-content-center">
                        {data.map((single, i) => {
                            return (
                                <div
                                    className="col-xl-4 col-lg-3 col-sm-6 mb-5"
                                    key={i}
                                >
                                    <div className="sidbar-menu align-items-center pdf-div">
                                        <ul>
                                            <li>
                                                <NavLink
                                                    target="_blank"
                                                    activeClassName="active"
                                                    className="padding-15 pdf-div-trans "
                                                    to="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        if (single.link == "") {
                                                            handleModalOpen(
                                                                true
                                                            );
                                                        } else {
                                                            window.open(
                                                                process.env
                                                                    .PUBLIC_URL +
                                                                    single.link,
                                                                "_blank"
                                                            );
                                                        }
                                                    }}
                                                >
                                                    <i className="fa fa-download px-2">
                                                        &nbsp;&nbsp;
                                                    </i>
                                                    <p
                                                        className="font-14 justify-content-center"
                                                        ref={(el) =>
                                                            (textRefs.current[
                                                                i
                                                            ] = el)
                                                        }
                                                    >
                                                        {single.name}
                                                    </p>
                                                </NavLink>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            {modalItem && (
                <div
                    className="modal-backdrop"
                    onClick={handleModalClose}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) =>
                        (e.key === "Enter" || e.key === " ") &&
                        handleModalClose()
                    }
                    aria-label="Modal Backdrop"
                >
                    <div
                        className="modal-content"
                        onClick={(e) => e.stopPropagation()}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                e.stopPropagation();
                                handleModalClose();
                            }
                        }}
                        role="button"
                        tabIndex={0}
                    >
                        <button
                            className="modal-close"
                            onClick={handleModalClose}
                            aria-label="Close Modal"
                        >
                            &times;
                        </button>

                        <h3
                            style={{ color: "green", marginBottom: "20px" }}
                            className="text-center"
                        >
                            Nothing to display
                        </h3>
                        <hr />

                        <button
                            className="btn btn-xm btn-primary btn-hover-primary mx-auto"
                            aria-label="Close Modal"
                            onClick={handleModalClose}
                            style={{
                                marginTop: "10px",
                                alignSelf: "center",
                                width: "120px",
                            }}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

FinancialResultsContainer.propTypes = {
    data: PropTypes.array,
    contRef: PropTypes.any,
};

export default FinancialResultsContainer;
